import React from 'react';

interface IClickItem {
  date: string,
  email: string,
  url: string
}

interface IClickReportGroupProps {
  items: Array<IClickItem>
};

class ClickReportGroup extends React.Component<IClickReportGroupProps> {
  state = {
    collapsed: true
  };

  toggle = () => {
    this.setState({ collapsed: !this.state.collapsed })
  }

  render() {
    const { items } = this.props;
    if (items.length === 0)
      return;

    return (
      <div>
        <h4 onClick={this.toggle}>{items[0].url} - {items.length}</h4>
        <table className='table' hidden={this.state.collapsed}>
          <thead>
            <tr>
              <td>Date</td>
              <td>Email</td>
            </tr>
          </thead>
          <tbody>
            {
              items.map(item => {
                return (
                  <tr>
                    <td>{item.date}</td>
                    <td>{item.email}</td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
    );
  }
}

export { ClickReportGroup };
